import { render, staticRenderFns } from "./transcription-table.vue?vue&type=template&id=1351733c&lang=pug&"
import script from "./transcription-table.vue?vue&type=script&lang=ts&"
export * from "./transcription-table.vue?vue&type=script&lang=ts&"
import style0 from "./transcription-table.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports